import React, { useEffect } from 'react';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { PageHero } from '../../components/PageHero';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Users, Award, Scale, Map, Mountain, Tent, FolderOpen, ArrowRight } from 'lucide-react';
const sections = [{
  name: 'Комітет альпінізму',
  href: '/alpinism/committee',
  icon: <Users className="h-5 w-5" data-id="element-399" />,
  description: 'Керівний орган альпіністського напрямку ФАіСУ.'
}, {
  name: 'Тренерська рада',
  href: '/alpinism/coach-council',
  icon: <Award className="h-5 w-5" data-id="element-400" />,
  description: 'Тренерська рада комітету альпінізму ФАіСУ.'
}, {
  name: 'Суддівська колегія',
  href: '/alpinism/judges',
  icon: <Scale className="h-5 w-5" data-id="element-401" />,
  description: 'Суддівська колегія комітету альпінізму ФАіСУ.'
}, {
  name: 'Комісія з класифікації маршрутів',
  href: '/alpinism/route-classification',
  icon: <Map className="h-5 w-5" data-id="element-402" />,
  description: 'Класифікація та оцінка альпіністських маршрутів.'
}, {
  name: 'Комісія зі Скі-альпінізму та Скайранінгу',
  href: '/alpinism/ski-alpinism',
  icon: <Mountain className="h-5 w-5" data-id="element-403" />,
  description: 'Розвиток скі-альпінізму та скайранінгу в Україні.'
}, {
  name: 'Комісія з аматорського альпінізму',
  href: '/alpinism/amateur',
  icon: <Tent className="h-5 w-5" data-id="element-404" />,
  description: 'Розвиток аматорського альпінізму в Україні.'
}, {
  name: 'Документи',
  href: '/alpinism/documents',
  icon: <FolderOpen className="h-5 w-5" data-id="element-405" />,
  description: 'Офіційні документи комітету альпінізму ФАіСУ.'
}];
export function AlpinismIndex() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-gray-50" data-id="element-406">
      <Header data-id="element-407" />
      <main className="pt-20" data-id="element-408">
        <PageHero label="Альпінізм" title="Альпінізм" subtitle="Структура комітету альпінізму Федерації Альпінізму і Скелелазіння України — комісії, ради та робочі органи." data-id="element-409" />

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pb-20" data-id="element-410">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-411">
            {sections.map((section, index) => <motion.div key={section.href} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: index * 0.06,
            duration: 0.4
          }} data-id="element-412">
                <Link to={section.href} className="block bg-white rounded-lg border border-gray-200 shadow-sm p-6 group cursor-pointer hover:border-primary/20 hover:shadow-md transition-all" data-id="element-413">
                  <div className="flex items-start gap-4" data-id="element-414">
                    <div className="p-2.5 bg-primary/5 rounded-lg border border-primary/10 flex-shrink-0 text-primary group-hover:bg-primary group-hover:text-white transition-colors" data-id="element-415">
                      {section.icon}
                    </div>
                    <div className="flex-1 min-w-0" data-id="element-416">
                      <div className="flex items-center justify-between" data-id="element-417">
                        <h3 className="text-sm font-bold text-primary group-hover:text-primary-light transition-colors" data-id="element-418">
                          {section.name}
                        </h3>
                        <ArrowRight className="h-4 w-4 text-gray-300 group-hover:text-primary transition-colors flex-shrink-0" data-id="element-419" />
                      </div>
                      <p className="text-gray-500 text-sm mt-1.5 leading-relaxed" data-id="element-420">
                        {section.description}
                      </p>
                    </div>
                  </div>
                </Link>
              </motion.div>)}
          </div>
        </div>
      </main>
      <Footer data-id="element-421" />
    </div>;
}